import React, {useEffect, useState} from 'react';
import {useLocation, useNavigate} from "react-router-dom";
import { GridLoader } from "react-spinners";
import Footer from "../../Componants/Footer";
import {Ajax} from "../../Service/ajax";
import Swal from "sweetalert2";

export default function WithdrawalConfirmationView() {
    const navigate = useNavigate();
    const [loading, setLoading] = useState(false);
    const [code, setCode] = useState("");
    const location = useLocation();
    const company = location.state?.company;
    const presence = location.state?.presence;

    useEffect(() => {
        if (!location.state?.company) {
            navigate(-1);
        }
    },[])

    const handleConfirm = async () => {
        if (code.length < 4 || code.length > 5) {
            alert("Le code doit contenir entre 4 et 5 chiffres.");
            return;
        }
        try {
            const {data} = await Ajax.postRequest("/api/v1/trs/transactions/requests/confirm", {token: code, owner: company.id});
            if(!data.error){
                Swal.fire({
                    title: "Success!",
                    text: data.message,
                    icon: 'success',
                    confirmButtonText: 'OK',
                    timerProgressBar: true,
                    customClass: {
                        popup: 'custom-popup',
                        confirmButton: 'custom-button'
                    },
                    timer: 10000
                }).then((result) => {
                    if (result.isConfirmed || result.dismiss === Swal.DismissReason.timer) {
                        if(presence === "withdrawal"){
                            navigate(-2);
                        }else{
                            navigate(-1);
                        }
                    }
                });
            }else{
                Swal.fire({
                    title: "Error",
                    text: data.message,
                    icon: 'error',
                    confirmButtonText: 'OK',
                    timerProgressBar: true,
                    customClass: {
                        popup: 'custom-popup',
                        confirmButton: 'custom-button'
                    },
                    timer: 10000
                }).then((result) => {
                    if (result.isConfirmed || result.dismiss === Swal.DismissReason.timer) {
                        if(presence === "withdrawal"){
                            navigate(-2);
                        }else{
                            navigate(-1);
                        }
                    }
                });
            }

        }catch(e) {
            Swal.fire({
                title: "Error",
                text: e.message,
                icon: 'error',
                confirmButtonText: 'OK',
                timerProgressBar: true,
                customClass: {
                    popup: 'custom-popup',
                    confirmButton: 'custom-button'
                },
                timer: 10000
            }).then((result) => {
                if (result.isConfirmed || result.dismiss === Swal.DismissReason.timer) {
                    if(presence === "withdrawal"){
                        navigate(-2);
                    }else{
                        navigate(-1);
                    }
                }
            });
        }
    };

        return (
            <>
                {loading ? (
                    <div className="loading-overlay">
                        <div className="loading-spinner">
                            <GridLoader
                                color="#debf66"
                                loading
                                size={15}
                            />
                        </div>
                    </div>
                ) : (
                    <div className="layout-wrapper layout-content-navbar layout-without-menu">
                        <div className="layout-container">
                            <div className="layout-page">
                                <nav className="navbar navbar-example navbar-expand-lg bg-light layout-navbar-fixed">
                                    <div className="container-fluid">
                                        <a type="button" className="display-7 text-black fw-bolder"
                                           onClick={() => navigate("/")}>
                                            <img
                                                src={require("../../assets/img/illustrations/Netikash subscribe-2.png")}
                                                alt="Netikash Logo" className="mb-3" style={{width: 150}}/>
                                        </a>
                                    </div>
                                </nav>

                                <div className="content-wrapper">
                                    <div className="container-xxl flex-grow-1 container-p-y">
                                        <div className="col-md-12 d-flex justify-content-center align-items-center"
                                             style={{minHeight: "60vh"}}>
                                            <div
                                                className="d-flex flex-column justify-content-center align-items-center w-100"
                                                style={{maxWidth: 400}}>
                                                <i className="bx bx-lock-alt mb-3"
                                                   style={{fontSize: "6rem", color: "#eccd7e"}}></i>
                                                <h3 className="text-center mb-3">Confirmation de retrait</h3>
                                                <p className="text-center mb-4">
                                                    Un code de confirmation vous a été envoyé par WhatsApp ou par SMS.
                                                    Veuillez l’entrer ci-dessous pour finaliser votre retrait.
                                                </p>

                                                <input
                                                    type="number"
                                                    className="form-control mb-4 text-center"
                                                    placeholder="Entrez le code (max 5 chiffres)"
                                                    maxLength={5}
                                                    value={code}
                                                    onChange={(e) => {
                                                        const val = e.target.value;
                                                        if (/^\d{0,5}$/.test(val)) setCode(val);
                                                    }}
                                                    style={{
                                                        fontSize: '1.5rem',
                                                        letterSpacing: '4px',
                                                        maxWidth: '250px'
                                                    }}
                                                />

                                                <div className="d-flex justify-content-center gap-3">
                                                    <button className="btn btn-secondary" onClick={() => navigate(-1)}>
                                                        Annuler
                                                    </button>
                                                    <button className="btn btn-netikash" onClick={handleConfirm}>
                                                        Confirmer
                                                    </button>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                    <div className="content-backdrop fade"></div>
                                </div>

                                <Footer/>
                            </div>
                        </div>
                    </div>
                )}
            </>
        );
    }
